import { render } from "./ContinousImprovement.vue?vue&type=template&id=4bf83f64&scoped=true"
import script from "./ContinousImprovement.vue?vue&type=script&lang=js"
export * from "./ContinousImprovement.vue?vue&type=script&lang=js"

import "./ContinousImprovement.vue?vue&type=style&index=0&id=4bf83f64&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf83f64"]])

export default __exports__